import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Statut d'un export (enum App\\Entity\\ExportStatus de l'API, GET /export_statuses) : En attente, En cours, Terminé, Échoué */
export default class ExportStatusModel extends AbstractApiModel {
  protected _path = '/export_statuses/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:export_status:${this.id}`);
  }
}
